import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/skype': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M424.7 299.8c14.6 18.9 23.3 42.5 23.2 68.1 0 61.8-50.2 112-112 112-25.6 0-49.2-8.7-68.2-23.3-14.1 3-28.9 4.7-43.8 4.7-113.4 0-205.3-91.8-205.3-205.3 0-14.9 1.8-29.8 4.7-43.8-14.6-18.9-23.3-42.5-23.3-68.2 0-61.8 50.2-112 112-112 25.7 0 49.3 8.7 68.3 23.4 14.1-3 28.9-4.7 43.8-4.7 113.4 0 205.3 91.8 205.3 205.3 0 14.9-1.8 29.8-4.7 43.8zM230.1 391.3c54.9 0 112-27.4 112-86.5 0-50.8-49.3-68.3-90.7-77.6-48.3-11.2-69.1-13.2-69.1-33 0-15.5 16.3-22.5 42-22.5 45.8 0 46.7 33.5 75 33.5 18.9 0 30.3-14.9 30.3-31.8 0-33.5-55.7-55.4-110.8-55.4-50.5 0-109.1 21.9-109.1 81.1 0 65.2 55.3 71.8 117.8 87.2 26 6.4 42 9.3 42 28 0 14.9-16.6 26.3-42.3 26.3-54 0-56.9-44.9-88.1-44.9-20.5 0-29.5 14.6-29.5 30.6 0 35.8 54.9 65 120.5 65z'
      }
    ]
  }
})
